// extracted by mini-css-extract-plugin
export default {"productcard":"ZT","productimage":"aU","username":"bU","multiBagName":"cU","productinfo":"eU","productinfoinner":"fU","productname":"gU","productsubheader":"hU","productdescription":"iU","productnumbers":"jU","productnumberstitle":"kU","productnumbersitem":"lU","number":"mU","numbertext":"nU","tabs":"oU","benefitsblock":"pU","benefit":"qU","benefitname":"rU","benefitdescription":"sU","ingredientsblock":"tU","tipsblock":"uU","mobileonly":"vU"};
    if(module.hot) {
      // 1726593107366
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  